/**
 * Adds checked shop-the-look variants together with the main product on add to cart.
 */
(function () {
  if (window.__shopTheLookInit) {
    return;
  }

  window.__shopTheLookInit = true;

  function getMainVariantId(form) {
    var variantInput = form.querySelector('[name="id"]');
    return variantInput ? variantInput.value : null;
  }

  function getCheckedItems(container) {
    var items = [];

    container.querySelectorAll('[data-shop-the-look-item]').forEach(function (card) {
      var checkbox = card.querySelector('[data-shop-the-look-checkbox]');

      if (!checkbox || !checkbox.checked) {
        return;
      }

      var variantField = card.querySelector('[data-shop-the-look-variant]');
      var variantId = variantField ? variantField.value : null;

      if (variantId) {
        items.push({
          id: parseInt(variantId, 10),
          quantity: 1
        });
      }
    });

    return items;
  }

  function showError(button, message) {
    var existingError = button.parentElement.querySelector('.ProductForm__Error');

    if (existingError) {
      existingError.remove();
    }

    var errorMessageElement = document.createElement('span');
    errorMessageElement.className = 'ProductForm__Error Alert Alert--error';
    errorMessageElement.innerHTML = message;
    button.removeAttribute('disabled');
    button.insertAdjacentElement('afterend', errorMessageElement);

    setTimeout(function () {
      errorMessageElement.remove();
    }, 5000);
  }

  function updateCardSelectedState(card) {
    var checkbox = card.querySelector('[data-shop-the-look-checkbox]');
    card.classList.toggle('is-selected', Boolean(checkbox && checkbox.checked));
  }

  function updateAddToCartButton(container) {
    if (!container) {
      return;
    }

    var form = container.closest('form.ProductForm, form[action*="/cart/add"]');

    if (!form) {
      return;
    }

    var button = form.querySelector('.ProductForm__AddToCart');

    if (!button || !button.hasAttribute('data-action')) {
      return;
    }

    var labelSpan = button.querySelector('span');

    if (!labelSpan) {
      return;
    }

    if (!button.dataset.shopTheLookDefaultLabel) {
      button.dataset.shopTheLookDefaultLabel = labelSpan.textContent.trim();
    }

    var checkedCount = container.querySelectorAll('[data-shop-the-look-checkbox]:checked').length;
    var productsLabelTemplate = container.getAttribute('data-add-products-label');

    if (checkedCount === 0) {
      labelSpan.textContent = button.dataset.shopTheLookDefaultLabel;
      button.removeAttribute('aria-label');
      return;
    }

    if (!productsLabelTemplate) {
      return;
    }

    var totalCount = 1 + checkedCount;
    var productsLabel = productsLabelTemplate.replace(/__COUNT__|\{\{\s*count\s*\}\}/g, String(totalCount));

    labelSpan.textContent = productsLabel;
    button.setAttribute('aria-label', productsLabel);
  }

  document.addEventListener('change', function (event) {
    var checkbox = event.target.closest('[data-shop-the-look-checkbox]');

    if (!checkbox) {
      return;
    }

    var card = checkbox.closest('[data-shop-the-look-item]');
    var container = checkbox.closest('[data-shop-the-look]');

    if (card) {
      updateCardSelectedState(card);
    }

    updateAddToCartButton(container);
  });

  document.addEventListener('change', function (event) {
    var variantSelect = event.target.closest('[data-shop-the-look-variant]');

    if (!variantSelect || variantSelect.tagName !== 'SELECT') {
      return;
    }

    var card = variantSelect.closest('[data-shop-the-look-item]');
    var priceEl = card ? card.querySelector('[data-shop-the-look-price]') : null;
    var option = variantSelect.selectedOptions[0];

    if (priceEl && option && option.dataset.priceFormatted) {
      priceEl.textContent = option.dataset.priceFormatted;
    }
  });

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-action="add-to-cart"]');

    if (!button || button.disabled) {
      return;
    }

    var form = button.closest('form.ProductForm, form[action*="/cart/add"]');

    if (!form) {
      return;
    }

    if (form.querySelector('[data-gift-bag]')) {
      return;
    }

    var container = form.querySelector('[data-shop-the-look]');

    if (!container) {
      return;
    }

    var upsellItems = getCheckedItems(container);

    if (upsellItems.length === 0) {
      return;
    }

    var mainVariantId = getMainVariantId(form);

    if (!mainVariantId) {
      return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();

    if (!window.routes || !window.routes.cartAddUrl) {
      return;
    }

    var useAjaxCart = container.getAttribute('data-use-ajax-cart') === 'true';
    var quantityInput = form.querySelector('[name="quantity"]');
    var quantity = Math.max(1, parseInt(quantityInput && quantityInput.value ? quantityInput.value : '1', 10) || 1);
    var items = [{ id: parseInt(mainVariantId, 10), quantity: quantity }].concat(upsellItems);

    button.setAttribute('disabled', 'disabled');
    document.dispatchEvent(new CustomEvent('theme:loading:start'));

    fetch(window.routes.cartAddUrl + '.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ items: items })
    }).then(function (response) {
      document.dispatchEvent(new CustomEvent('theme:loading:end'));

      if (response.ok) {
        button.removeAttribute('disabled');

        if (!useAjaxCart) {
          window.location.href = window.routes.cartUrl;
          return;
        }

        var productSection = form.closest('.Product') || form;

        productSection.dispatchEvent(new CustomEvent('product:added', {
          bubbles: true,
          detail: {
            quantity: quantity
          }
        }));
      } else {
        response.json().then(function (content) {
          showError(button, content.description || 'Add to cart failed');
        });
      }
    }).catch(function () {
      document.dispatchEvent(new CustomEvent('theme:loading:end'));
      button.removeAttribute('disabled');
    });
  }, true);

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-shop-the-look-item]').forEach(updateCardSelectedState);
    document.querySelectorAll('[data-shop-the-look]').forEach(updateAddToCartButton);
  });
})();
